














































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import http from "@/axios/http-common";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import TandaVital from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/TandaVital.vue";
import Antropometri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Antropometri.vue";
import Nyeri from "@/components/pemeriksaan/assesmen/pemeriksaanfisik/Nyeri.vue";
import DataPemeriksaanFisikRalan from "@/services/DataPemeriksaanFisikRalan";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    TandaVital,
    Antropometri,
    Nyeri,
  },
})
export default class PemeriksaanFisik extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() dtpemeriksaan!: object;

  sess_login = userModule.user;
  getparam = {
    unit_id: this.sess_login.unit_id,
    reg: this.register,
  };
  tanda_vital = {
    sistole: null,
    diastole: null,
    frekuensi_nadi: null,
    frekuensi_nafas: null,
    suhu_badan: null,
    saturasi_oksigen: null,
    keadaan_umum: "",
    kesadaran: "",
  };
  antropometri = {
    berat_badan: null,
    tinggi_badan: null,
    imt: null,
    lingkar_kepala: null,
    lla: null,
  };
  nyeri = {
    skala: 0,
    lokasi: "",
    durasi: null,
    frekuensi: null,
    pencetus: "",
    kualitas: "",
    pola_serangan: "",
    penyebab_hilang: "",
    jenis: "0",
  };
  transfer = false;

  get textHeaderTandaVital() {
    // console.log("textHeaderTandaVital", this.tanda_vital);
    const td =
      this.tanda_vital.sistole && this.tanda_vital.diastole
        ? "TD: " +
          this.tanda_vital.sistole +
          "/" +
          this.tanda_vital.diastole +
          "mmHg"
        : "";
    const nd = this.tanda_vital.frekuensi_nadi
      ? "Nadi: " + this.tanda_vital.frekuensi_nadi + "x/menit"
      : "";
    const nf = this.tanda_vital.frekuensi_nafas
      ? "RR: " + this.tanda_vital.frekuensi_nafas + "x/menit"
      : "";
    const sb = this.tanda_vital.suhu_badan
      ? "SB: " + this.tanda_vital.suhu_badan + "C"
      : "";
    const o2 = this.tanda_vital.saturasi_oksigen
      ? "SpO2: " + this.tanda_vital.saturasi_oksigen + "%"
      : "";
    const ku = this.tanda_vital.keadaan_umum
      ? this.tanda_vital.keadaan_umum
      : "";
    const kesadaran = this.tanda_vital.kesadaran
      ? this.tanda_vital.kesadaran
      : "";

    return [td, nd, nf, sb, o2, ku, kesadaran].filter(Boolean).join("; ");
  }

  get textHeaderAntropometri() {
    const bb = this.antropometri.berat_badan
      ? "BB: " + this.antropometri.berat_badan + "kg"
      : "";
    const tb = this.antropometri.tinggi_badan
      ? "TB: " + this.antropometri.tinggi_badan + "cm"
      : "";
    const imt = this.antropometri.imt ? "IMT: " + this.antropometri.imt : "";
    const lk = this.antropometri.lingkar_kepala
      ? "Lingkar Kepala: " + this.antropometri.lingkar_kepala + "cm"
      : "";
    const lla = this.antropometri.lla
      ? "LLA: " + this.antropometri.lla + "cm"
      : "";

    return [bb, tb, imt, lk, lla].filter(Boolean).join("; ");
  }

  get textHeaderNyeri() {
    // console.log("snyeri", this.statePemeriksaanFisikRalan.nyeri);

    let skala = "";
    if (this.nyeri.skala == 0) {
      skala = "Tidak Nyeri";
    } else if (this.nyeri.skala < 4) {
      skala = "Nyeri Ringan";
    } else if (this.nyeri.skala < 7) {
      skala = "Nyeri Sedang";
    } else {
      skala = "Nyeri Berat";
    }
    let jenis = "";
    if (this.nyeri.jenis == "1") {
      jenis = "Jenis: Akut";
    } else if (this.nyeri.jenis == "2") {
      jenis = "Jenis: Kronis";
    } else {
      jenis = "";
    }

    const sn = this.nyeri.skala
      ? "Skala: " + this.nyeri.skala + "(" + skala + ")"
      : "";
    const lo = this.nyeri.lokasi ? "Lokasi: " + this.nyeri.lokasi : "";
    const du = this.nyeri.durasi ? "Durasi: " + this.nyeri.durasi : "";
    const fr = this.nyeri.frekuensi ? "Frek.: " + this.nyeri.frekuensi : "";
    const pc = this.nyeri.pencetus ? "Pencetus: " + this.nyeri.pencetus : "";

    const kn = this.nyeri.kualitas ? "Kualitas: " + this.nyeri.kualitas : "";
    const ps = this.nyeri.pola_serangan
      ? "Pola Serangan: " + this.nyeri.pola_serangan
      : "";
    const ph = this.nyeri.penyebab_hilang
      ? "Penyebab Hilang: " + this.nyeri.penyebab_hilang
      : "";
    const jn = this.nyeri.jenis ? "" + jenis : "";

    return [sn, lo, du, fr, pc, kn, ps, ph, jn].filter(Boolean).join("; ");
  }

  setAntropometri(val) {
    // console.log("setAntropometri ", val);

    this.antropometri = val;
  }
  setNyeri(val) {
    this.nyeri = val;
  }
  // get stateAsesmenAwal() {
  //   return storeAssesmenRalan.asesmenAwal;
  // }

  //   get statePemeriksaanFisikRalan() {
  //     return storePemeriksaanFisikRalan.pemeriksaanfisikralan;
  //   }
  setTandaVital(val) {
    // console.log("setTandaVital", val);
    this.tanda_vital = val;
  }

  @Watch("dtpemeriksaan")
  changePemeriksaanFisikRalan(val) {
    // if (this.btntransfer == true) {
    if (
      val.tanda_vital == null &&
      val.antropometri == null &&
      val.nyeri == null
    ) {
      this.transfer = false;
    } else {
      this.transfer = true;
    }
    // }
    if (val.tanda_vital == null) {
      this.tanda_vital = {
        sistole: null,
        diastole: null,
        frekuensi_nadi: "",
        frekuensi_nafas: "",
        suhu_badan: "",
        saturasi_oksigen: "",
        keadaan_umum: "",
        kesadaran: "",
      };
    } else {
      this.tanda_vital = val.tanda_vital;
    }
    if (val.antropometri == null) {
      this.antropometri = {
        berat_badan: "",
        tinggi_badan: "",
        imt: "",
        lingkar_kepala: "",
        lla: "",
      };
    } else {
      this.antropometri = val.antropometri;
    }
    if (val.nyeri == null) {
      this.nyeri = {
        skala: 0,
        lokasi: "",
        durasi: "",
        frekuensi: "",
        pencetus: "",
        kualitas: "",
        pola_serangan: "",
        penyebab_hilang: "",
        jenis: "0",
      };
    } else {
      this.nyeri = val.nyeri;
    }
  }
}
